import { render } from "./SuchfeldDetailVx.vue?vue&type=template&id=63dcbd50&scoped=true"
import script from "./SuchfeldDetailVx.vue?vue&type=script&lang=js"
export * from "./SuchfeldDetailVx.vue?vue&type=script&lang=js"

import "./SuchfeldDetailVx.vue?vue&type=style&index=0&id=63dcbd50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dcbd50"]])

export default __exports__